import { useSeo } from "@/lib/useSeo";
import { Btn } from "@/components/site/kit";

export default function NotFound() {
  useSeo({ title: "Page Not Found" });
  return (
    <section className="relative overflow-hidden bg-white" data-testid="not-found-page">
      <div className="dot-grid absolute inset-0 opacity-60" aria-hidden="true" />
      <div className="container-x relative flex min-h-[70vh] flex-col items-center justify-center py-20 text-center">
        <p className="font-heading text-[7rem] font-extrabold leading-none text-indigo-brand sm:text-[10rem]">4<span className="text-sky">0</span>4</p>
        <h1 className="mt-4 text-3xl font-extrabold sm:text-4xl">This page went <span className="text-ocean">offline</span></h1>
        <p className="mt-4 max-w-md text-body">The page you're looking for doesn't exist or has been moved. Let's get you back on track.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Btn to="/" testId="not-found-home-btn">Back to Home</Btn>
          <Btn to="/contact" variant="secondary" testId="not-found-contact-btn">Contact Us</Btn>
        </div>
      </div>
    </section>
  );
}
